import CloseIcon from '@mui/icons-material/Close';
import { Box, DialogTitle, DialogTitleProps, IconButton } from '@mui/material';
import React from 'react';
import { useTranslate } from 'react-admin';

export const DialogTitleWithX = ({
  children,
  onClose,
  ...rest
}: DialogTitleProps & {
  onClose?: React.MouseEventHandler<HTMLButtonElement>;
}) => {
  const translate = useTranslate();

  if (onClose) {
    return (
      <DialogTitle {...rest}>
        <Box display="flex" alignItems="center">
          <Box flexGrow={1}>{children}</Box>
          <Box>
            <IconButton
              onClick={onClose}
              aria-label={translate('resources.bo_common.accessibility.close')}
              data-testid="BoExternalDialogTitleWithX_CloseButton">
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>
      </DialogTitle>
    );
  }
  return <DialogTitle {...rest} />;
};
